export default "__VITE_ASSET__c88540e2__"